<template lang="pug">
  .sidebar-wrap
    .block.block-1
        h3 Öffnungszeiten:
        p <strong>Dienstag</strong><br>
            | 17:00 Uhr bis 22:00 Uhr<br>
            | (Küche bis 21:00 Uhr)       
        p <strong>Mittwoch - Sonntag</strong><br>
            | 12:00 Uhr bis 14:30 Uhr<br>
            | 17:00 Uhr bis 22:00 Uhr<br>
            | (Küche bis 21:00 Uhr)
    .block.block-2
        h3 So erreichen Sie uns:
        p Judenstraße 8, <br> 47906 Kempen
        p <strong>T</strong> <a href="tel:004921529946028">02152 / 994 602 8</a><br>
            | <strong>E</strong> <a href="mailto:kontakt@restaurant-ercklentz.de">kontakt@restaurant-ercklentz.de</a>
        h3.nm Reservierungen:
        p <a href="mailto:reservierung@restaurant-ercklentz.de">reservierung@restaurant-ercklentz.de</a>
    .block.block-3
        h3 Zahlungsmöglichkeiten:
        img.payment(v-if="webpSupport" src="~@/assets/img/payment.webp", width="200", height="154", alt="Zahlungsmöglichkeiten")
        img.payment(v-else src="~@/assets/img/payment.png", width="200", height="154", alt="Zahlungsmöglichkeiten")
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: 'PageSidebar',
    computed: {
        ...mapGetters({
            webpSupport: 'webpSupport'
        })
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.sidebar-wrap
    @apply mt-12
    .block
        @apply p-6 mb-2 text-center
        background-color: #F0F1F1
        &.block-1
            background: linear-gradient(0deg, rgba(240,241,241,1) 50%, rgba(255,255,255,1) 100%)
        &.block-3
            background: linear-gradient(180deg, rgba(240,241,241,1) 50%, rgba(255,255,255,1) 100%)
        h3
            @apply text-xl font-bold mb-4
            &.nm
                @apply mb-0
        p
            @apply mb-4
            a
                &:hover
                    @apply font-semibold
        img
            margin: 0 auto
</style>
